import React from 'react'
import ProBadge from '../1Atoms/ProBadge'

export default function BeautifulMessage(props) {
  return (
    <div className="free-msg fade-in">
      { props.free &&
        <div>
          <h1>Upgrade to pro?</h1>
          <p>
           Upgrade to pro message
          </p>
        </div>
      }
      { props.pro &&
        <div>
          <p>
            Thank you for supporting!
          </p>
        </div>
      }
      { props.incomplete &&
        <div>
          <h1>Thanks!</h1>
          <p>
            Your subscription is incomplete!
          </p>
        </div>
      }
      { props.login &&
        <div>
          <h1>Become a PRO user</h1>
          <p>
            Login to access your account.
          </p>
        </div>
      }
    </div>
  )
}
